export default __webpack_public_path__ + "static/media/Payments.36306dab.svg";